import { useMutation, useQuery, useQueryClient } from "react-query";
import { http } from "src/api/http";

export function useGetHqActivities() {
  return useQuery<{ name: string }[]>({
    queryKey: ["hqUserActivities"],
    queryFn: () => http("/api/hq/cx-activities")
  });
}

export function useHqActivityUpdateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { name: string }[]) => http("/api/hq/cx-activities", {
      method: "PUT",
      body,
    }),
    onSuccess: () => queryClient.invalidateQueries(['hqUserActivities'])
  });
}